import { FunctionComponent } from "react";
import Icon from "@mdi/react";
import { mdiInformationOutline } from "@mdi/js";
import { useOrderDetailCtx } from "../../../../context_providers/order_detail_context";

const CurrencyInfoSection: FunctionComponent = () => {
  const { order } = useOrderDetailCtx();

  const currency = order.currency || {
    short_name: "INR",
    symbol: "₹",
    formal_name: "Indian Rupee",
  };
  const exchangeRate = order.currency_to_inr || 1;
  const isNotINR = currency.short_name !== "INR";

  return (
    <div className="bg-white rounded-md shadow p-5 mb-5">
      <h3 className="font-semibold mb-3">Currency Information</h3>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm">
        <div>
          <label className="block mb-1 font-medium">Billing Currency</label>
          <input
            disabled
            value={`${currency.formal_name} (${currency.symbol})`}
            className="p-2 border rounded w-full bg-gray-100"
          />
        </div>

        {isNotINR && (
          <div>
            <label className="block mb-1 font-medium">
              Exchange Rate (₹ per {currency.short_name})
            </label>
            <input
              disabled
              value={exchangeRate}
              className="p-2 border rounded w-full bg-gray-100"
            />
          </div>
        )}
      </div>

      <div className="flex gap-2 items-start text-gray-500 text-xs mt-2">
        <Icon path={mdiInformationOutline} size={0.6} />
        <p>
          This order was created in <strong>{currency.formal_name}</strong>.
          {isNotINR
            ? ` 1 ${currency.short_name} = ₹${exchangeRate}`
            : " All values are already in INR."}
        </p>
      </div>
    </div>
  );
};

export default CurrencyInfoSection;
